// extracted by mini-css-extract-plugin
export default {"container":"SubstituteSelect_container__98xz6","header":"SubstituteSelect_header__gJDPG","buttonWrapper":"SubstituteSelect_buttonWrapper__tTEzE"};